<au-impersonation-banner></au-impersonation-banner>
<div class="body bg-white">
  <main
    class="min-h-screen flex flex-column relative flex-auto main"
    [class.is-collapsed]="isCollapsed"
  >
    <au-header></au-header>
    <div class="m-5">
      <router-outlet></router-outlet>
    </div>
  </main>
</div>
